import React, { ReactElement, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '../../../Button'
import * as Styled from './styles'

interface NavListCreateNewButtonProps {
  centered?: boolean
  children?: ReactNode
  className?: string
  onClick?: () => void
}

export const NavListCreateNewButton = ({
  centered,
  children,
  onClick,
  className,
}: NavListCreateNewButtonProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Styled.NavListCreateNewButtonWrapper className={className} onClick={onClick}>
      <Styled.Separator />
      <Button icon="circlePlus" variant="text" size="md" fullWidth centered={centered}>
        {children || t('ds.nav_list.create_new')}
      </Button>
    </Styled.NavListCreateNewButtonWrapper>
  )
}
